import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from "react-router-dom";
import { ListGroup, Modal } from 'react-bootstrap';
import useAuth from 'hooks/useAuth'
const NavOrg = () => {
    const { config } = useAuth()
    const [hospitalName, setHospitalName] = useState()
    const [hospitalAddress, setHospitalAddress] = useState('')
    const [hospitalPhone, setHospitalPhone] = useState('')
    const [startBusinessTime, setStartBusinessTime] = useState('')
    const [endBusinessTime, setEndBusinessTime] = useState('')
    const [hospitalLogoUrl, setHospitalLogoUrl] = useState('')
    const [show, setShow] = useState(false)
    useEffect(() => {
        if (config) {

            //hospital_address
            //tax_hospital_number
            //hospital_phone
            //start_business_time
            //end_business_time

            setHospitalName(config.find(({ configCode }) => configCode === 'hospital_name')?.data || '')
            setHospitalAddress(config.find(({ configCode }) => configCode === 'hospital_address')?.data || '')
            setHospitalPhone(config.find(({ configCode }) => configCode === 'hospital_phone')?.data || '')
            setStartBusinessTime(config.find(({ configCode }) => configCode === 'start_business_time')?.data || '')
            setEndBusinessTime(config.find(({ configCode }) => configCode === 'end_business_time')?.data || '')
            setHospitalLogoUrl(config.find(({ configCode }) => configCode === 'hospital_logo_url')?.data || '')
        }
    }, [config])


    return (
        <React.Fragment>
            <Link to='#' className="f-20 pop-search" onClick={(e) => { e.preventDefault(); setShow(true) }}>{hospitalName}</Link>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <div className="d-flex w-100 align-items-center justify-content-between">
                        <div>
                            <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{hospitalName}</div>
                        </div>

                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-between align-items-start">
                        {/* Left side: Details */}
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '1rem', color: '#666' }}>ที่อยู่: {hospitalAddress}</div>
                            <div style={{ fontSize: '1rem', color: '#666' }}>เบอร์โทร: {hospitalPhone}</div>
                            <div style={{ fontSize: '1rem', color: '#666' }}>เวลาเปิด: {startBusinessTime}</div>
                            <div style={{ fontSize: '1rem', color: '#666' }}>เวลาปิด: {endBusinessTime}</div>
                        </div>

                        {/* Right side: Logo */}
                        <div style={{ marginLeft: '1rem' }}>
                            <img
                                src={hospitalLogoUrl}
                                alt="Hospital Logo"
                                style={{
                                    height: '100px',
                                    objectFit: 'contain',
                                }}
                            />
                        </div>
                    </div>
                </Modal.Body>


            </Modal>
        </React.Fragment>
    );
};

export default NavOrg;
